import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('toggleMessageOptionCheckbox')(function toggleMessageOptionCheckbox(field, checked, state) {
    var optionState = state.optionState;
    optionState[field] = checked;
}));
//# sourceMappingURL=toggleMessageOptionCheckbox.js.map